import * as types from '../action_types';

export const move = (data) => {
  return {
    type: types.MOVE_POINT_SUCCESS,
    payload: data,
  };
};
